var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
import { forwardRef } from "react";
var SvgEdit = function SvgEdit(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "none",
    height: 24,
    viewBox: "0 0 24 24",
    width: 24,
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    clipRule: "evenodd",
    d: "m19.6064 1.70708c.3905-.39053 1.0237-.39053 1.4142 0l1.4142 1.41421c.3905.39053.3905 1.02369 0 1.41421l-1.7071 1.70711-2.8284-2.82843zm-2.4142 2.41421 2.8284 2.82843-8.7782 8.77818-3.74263.7721.91421-3.6005zm-13.1922-1.12132h11.5741l-2 2h-8.5741v14.00003h14v-8.5744l2-2.00002v11.57442c0 .5523-.4477 1-1 1h-16c-.55228 0-1-.4477-1-1v-16.00003c0-.55228.44772-1 1-1z",
    fill: "currentColor",
    fillRule: "evenodd"
  })));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgEdit);
export default ForwardRef;